// GENERATED from the pristine reset() literal (script.js:93-384) — do not
// hand-edit. Regenerate: node test/tools/gen-state.js > src/engine/state.ts
// Key ORDER is the save format (JSON.stringify insertion order) — frozen.
// Byte-equality vs a fresh pristine boot is locked by test/game-state.test.js.

import { Dec, type Decimal } from '../shared/decimal'

export interface GameState {
  unlockedAchievements: number[]
  unlocks: number
  lastMajorChangeVersion: number
  lastUpdate: number
  lastSave: number
  lastSigilReset: number
  timePlayed: number
  backgroundPatternOn: boolean
  confirmations: boolean[]
  achievementFlashActive: boolean
  currentTab: number
  dragonName: string
  sigilResetterActive: boolean
  sigilResetterType: number
  sigilResetterMode: number
  sigilResetterAmount: Decimal
  sigilResetterGold: Decimal
  sigilResetterTime: Decimal
  sigilResetterCycle: boolean
  sigilResetterCycleMode: number
  gold: Decimal
  goldPerSecond: Decimal
  miners: Decimal
  minerCost: Decimal
  fire: Decimal
  firePerSecond: Decimal
  fireGoldMultiplier: Decimal
  fireAutoMaxAll: boolean
  fireUpgrade1Bought: Decimal
  fireUpgrade1Cost: Decimal
  fireUpgrade2Bought: Decimal
  fireUpgrade2Cost: Decimal
  fireUpgrade3Bought: Decimal
  fireUpgrade3Cost: Decimal
  fireUpgrade4Bought: Decimal
  fireUpgrade4Cost: Decimal
  fireUpgrade5Bought: Decimal
  fireUpgrade5Cost: Decimal
  fireUpgrade6Bought: Decimal
  fireUpgrade6Cost: Decimal
  dragonStage: number
  platinumConvertCooldown: number
  platinumToGet: Decimal
  bestPlatinumToGet: Decimal
  platinum: Decimal
  platinumUpgradesBought: number[]
  magic: Decimal
  magicToGet: Decimal
  magicEffect: Decimal
  goldPerClick: Decimal
  minerAutoBuyMax: boolean
  magicUpgradesBought: (Decimal | boolean)[]
  darkMagicUpgradesBought: (Decimal | boolean)[]
  voidMagicUpgradesBought: (Decimal | boolean)[]
  selectedChallenges: boolean[]
  challengesActive: boolean
  noOfSelectedChallenges: number
  magicScoreToGet: Decimal
  magicScore1: Decimal
  magicScore2: Decimal
  magicScore3: Decimal
  magicScore4: Decimal
  magifolds: Decimal
  uraniumConvertCooldown: number
  uraniumToGet: Decimal
  bestUraniumToGet: Decimal
  uranium: Decimal
  uraniumUpgradesBought: number[]
  dragonTimeSpent: Decimal
  dragonTimeCooldown: number
  dragonFood: Decimal
  dragonFeedCost: Decimal
  dragonTimeEffect: Decimal
  dragonPets: number
  cyanSigils: Decimal
  cyanSigilsToGet: Decimal
  cyanSigilPower: Decimal
  cyanSigilPowerPerSecond: Decimal
  cyanSigilUpgrade1Cost: Decimal
  cyanSigilUpgrade2Cost: Decimal
  cyanSigilUpgrade3Cost: Decimal
  cyanSigilUpgradesBought: Decimal[]
  blueSigils: Decimal
  blueSigilsToGet: Decimal
  blueSigilPower: Decimal
  blueSigilPowerPerSecond: Decimal
  blueSigilUpgrade1Cost: Decimal
  blueSigilUpgrade2Cost: Decimal
  blueSigilUpgrade3Cost: Decimal
  blueSigilUpgradesBought: Decimal[]
  indigoSigils: Decimal
  indigoSigilsToGet: Decimal
  indigoSigilPower: Decimal
  indigoSigilPowerPerSecond: Decimal
  indigoSigilUpgrade1Cost: Decimal
  indigoSigilUpgrade2Cost: Decimal
  indigoSigilUpgrade3Cost: Decimal
  indigoSigilUpgradesBought: Decimal[]
  violetSigils: Decimal
  violetSigilsToGet: Decimal
  violetSigilPower: Decimal
  violetSigilPowerPerSecond: Decimal
  violetSigilUpgrade1Cost: Decimal
  violetSigilUpgrade2Cost: Decimal
  violetSigilUpgradesBought: Decimal[]
  pinkSigils: Decimal
  pinkSigilsToGet: Decimal
  pinkSigilPower: Decimal
  pinkSigilPowerPerSecond: Decimal
  pinkSigilUpgrade1Cost: Decimal
  pinkSigilUpgrade3Cost: Decimal
  pinkSigilUpgradesBought: Decimal[]
  knowledge: Decimal
  highestKnowledge: Decimal
  knowledgeTradeLevel: Decimal
  knowledgeTradeLevelCap: Decimal
  knowledgeTrade1SigilTypes: number[]
  knowledgeTrade1Amounts: Decimal[]
  knowledgeTrade1Multipliers: Decimal[]
  knowledgeTrade1Reward: Decimal
  knowledgeTrade2SigilTypes: number[]
  knowledgeTrade2Amounts: Decimal[]
  knowledgeTrade2Multipliers: Decimal[]
  knowledgeTrade2Reward: Decimal
  knowledgeTrade3SigilTypes: number[]
  knowledgeTrade3Amounts: Decimal[]
  knowledgeTrade3Multipliers: Decimal[]
  knowledgeTrade3Reward: Decimal
  knowledgeUpgradesBought: Decimal[]
  knowledgeUpgradeCosts: Decimal[]
  knowledgeAutoMaxAll: boolean
  tomes: Decimal
  totalTomes: Decimal
  tomeCost: Decimal
  tomeUpgradesBought: (Decimal | boolean)[]
  blueFire: Decimal
  blueFirePerSecond: Decimal
  blueFireUpgradeCosts: Decimal[]
  blueFireUpgradesBought: Decimal[]
  blueFireAutoMaxAll: boolean
  blood: Decimal
  bloodPerSecond: Decimal
  currentHellLayer: number
  inHell: boolean
  plutoniumConvertCooldown: number
  plutoniumToGet: Decimal
  bestPlutoniumToGet: Decimal
  plutonium: Decimal
  plutoniumUpgradesBought: number[]
  redSigils: Decimal
  redSigilsToGet: Decimal
  redSigilPower: Decimal
  redSigilPowerPerSecond: Decimal
  redSigilUpgrade1Cost: Decimal
  redSigilUpgrade2Cost: Decimal
  redSigilUpgrade3Cost: Decimal
  redSigilUpgradesBought: Decimal[]
  orangeSigils: Decimal
  orangeSigilsToGet: Decimal
  orangeSigilPower: Decimal
  orangeSigilPowerPerSecond: Decimal
  orangeSigilUpgrade1Cost: Decimal
  orangeSigilUpgrade2Cost: Decimal
  orangeSigilUpgrade3Cost: Decimal
  orangeSigilUpgradesBought: Decimal[]
  yellowSigils: Decimal
  yellowSigilsToGet: Decimal
  yellowSigilPower: Decimal
  yellowSigilPowerPerSecond: Decimal
  yellowSigilUpgrade1Cost: Decimal
  yellowSigilUpgrade2Cost: Decimal
  yellowSigilUpgrade3Cost: Decimal
  yellowSigilUpgradesBought: Decimal[]
  holyTetrahedrons: Decimal
  holyTetrahedronsToGet: Decimal
  holyTetrahedronUpgradesUnlocked: boolean[]
  holyTetrahedronUpgradesBought: (Decimal | boolean)[]
  holyOctahedrons: Decimal
  holyOctahedronsToGet: Decimal
  holyOctahedronUpgradesUnlocked: boolean[]
  holyOctahedronUpgradesBought: (Decimal | boolean)[]
  holyFire: Decimal
  holyFirePerSecond: Decimal
  holyFireUpgradeCosts: Decimal[]
  holyFireUpgradesBought: Decimal[]
  holyFireAutoMaxAll: boolean
  holyDodecahedrons: Decimal
  holyDodecahedronsToGet: Decimal
  holyDodecahedronUpgradesUnlocked: boolean[]
  holyDodecahedronUpgradesBought: (Decimal | boolean)[]
  planets: Decimal
  planetEffect: Decimal
  planetCosts: Decimal[]
  planetsFormed: Decimal[]
  superclusters: Decimal
  superclusterCost: Decimal
  hypergodsDefeated: number
  cosmicPlague: Decimal
  cosmicPlaguePerSecond: Decimal
  spores: Decimal
  sporeCost: Decimal
  plagueUpgradeCosts: Decimal[]
  plagueUpgradesBought: Decimal[]
  plagueAutoMaxAll: boolean
  oganesson: Decimal
  oganessonPerSecond: Decimal
  oganessonUpgradesBought: number[]
  lightEssence: Decimal
  lightEssencePerSecond: Decimal
  lightEssenceUpgradeCosts: Decimal[]
  lightEssenceUpgradesBought: Decimal[]
  darkEssence: Decimal
  darkEssencePerSecond: Decimal
  darkEssenceUpgradeCosts: Decimal[]
  darkEssenceUpgradesBought: Decimal[]
  deathEssence: Decimal
  deathEssencePerSecond: Decimal
  deathEssenceUpgradeCosts: Decimal[]
  deathEssenceUpgradesBought: Decimal[]
  finalityEssence: Decimal
  finalityEssencePerSecond: Decimal
  finalityEssenceUpgradeCosts: Decimal[]
  finalityEssenceUpgradesBought: Decimal[]
  nuclearPasta: Decimal
  nuclearPastaCost: Decimal
  nuclearPastaState: number
  nuclearPastaStateInfo: boolean
  nuclearPastaCooldown: number
  nuclearPastaExtended: boolean
  nuclearPastaUpgradesBought: (Decimal | boolean)[]
  finalityCubes: Decimal
  finalityCubeCost: Decimal
  finalityCubeEffect: Decimal
  finalityBoosts: Decimal
  finalityBoostCost: Decimal
  finalityBoostBoosts: Decimal
  finalityBoostBoostCost: Decimal
}

/** The frozen 237-key save format, in save order. */
export const SAVE_KEYS = [
  'unlockedAchievements',
  'unlocks',
  'lastMajorChangeVersion',
  'lastUpdate',
  'lastSave',
  'lastSigilReset',
  'timePlayed',
  'backgroundPatternOn',
  'confirmations',
  'achievementFlashActive',
  'currentTab',
  'dragonName',
  'sigilResetterActive',
  'sigilResetterType',
  'sigilResetterMode',
  'sigilResetterAmount',
  'sigilResetterGold',
  'sigilResetterTime',
  'sigilResetterCycle',
  'sigilResetterCycleMode',
  'gold',
  'goldPerSecond',
  'miners',
  'minerCost',
  'fire',
  'firePerSecond',
  'fireGoldMultiplier',
  'fireAutoMaxAll',
  'fireUpgrade1Bought',
  'fireUpgrade1Cost',
  'fireUpgrade2Bought',
  'fireUpgrade2Cost',
  'fireUpgrade3Bought',
  'fireUpgrade3Cost',
  'fireUpgrade4Bought',
  'fireUpgrade4Cost',
  'fireUpgrade5Bought',
  'fireUpgrade5Cost',
  'fireUpgrade6Bought',
  'fireUpgrade6Cost',
  'dragonStage',
  'platinumConvertCooldown',
  'platinumToGet',
  'bestPlatinumToGet',
  'platinum',
  'platinumUpgradesBought',
  'magic',
  'magicToGet',
  'magicEffect',
  'goldPerClick',
  'minerAutoBuyMax',
  'magicUpgradesBought',
  'darkMagicUpgradesBought',
  'voidMagicUpgradesBought',
  'selectedChallenges',
  'challengesActive',
  'noOfSelectedChallenges',
  'magicScoreToGet',
  'magicScore1',
  'magicScore2',
  'magicScore3',
  'magicScore4',
  'magifolds',
  'uraniumConvertCooldown',
  'uraniumToGet',
  'bestUraniumToGet',
  'uranium',
  'uraniumUpgradesBought',
  'dragonTimeSpent',
  'dragonTimeCooldown',
  'dragonFood',
  'dragonFeedCost',
  'dragonTimeEffect',
  'dragonPets',
  'cyanSigils',
  'cyanSigilsToGet',
  'cyanSigilPower',
  'cyanSigilPowerPerSecond',
  'cyanSigilUpgrade1Cost',
  'cyanSigilUpgrade2Cost',
  'cyanSigilUpgrade3Cost',
  'cyanSigilUpgradesBought',
  'blueSigils',
  'blueSigilsToGet',
  'blueSigilPower',
  'blueSigilPowerPerSecond',
  'blueSigilUpgrade1Cost',
  'blueSigilUpgrade2Cost',
  'blueSigilUpgrade3Cost',
  'blueSigilUpgradesBought',
  'indigoSigils',
  'indigoSigilsToGet',
  'indigoSigilPower',
  'indigoSigilPowerPerSecond',
  'indigoSigilUpgrade1Cost',
  'indigoSigilUpgrade2Cost',
  'indigoSigilUpgrade3Cost',
  'indigoSigilUpgradesBought',
  'violetSigils',
  'violetSigilsToGet',
  'violetSigilPower',
  'violetSigilPowerPerSecond',
  'violetSigilUpgrade1Cost',
  'violetSigilUpgrade2Cost',
  'violetSigilUpgradesBought',
  'pinkSigils',
  'pinkSigilsToGet',
  'pinkSigilPower',
  'pinkSigilPowerPerSecond',
  'pinkSigilUpgrade1Cost',
  'pinkSigilUpgrade3Cost',
  'pinkSigilUpgradesBought',
  'knowledge',
  'highestKnowledge',
  'knowledgeTradeLevel',
  'knowledgeTradeLevelCap',
  'knowledgeTrade1SigilTypes',
  'knowledgeTrade1Amounts',
  'knowledgeTrade1Multipliers',
  'knowledgeTrade1Reward',
  'knowledgeTrade2SigilTypes',
  'knowledgeTrade2Amounts',
  'knowledgeTrade2Multipliers',
  'knowledgeTrade2Reward',
  'knowledgeTrade3SigilTypes',
  'knowledgeTrade3Amounts',
  'knowledgeTrade3Multipliers',
  'knowledgeTrade3Reward',
  'knowledgeUpgradesBought',
  'knowledgeUpgradeCosts',
  'knowledgeAutoMaxAll',
  'tomes',
  'totalTomes',
  'tomeCost',
  'tomeUpgradesBought',
  'blueFire',
  'blueFirePerSecond',
  'blueFireUpgradeCosts',
  'blueFireUpgradesBought',
  'blueFireAutoMaxAll',
  'blood',
  'bloodPerSecond',
  'currentHellLayer',
  'inHell',
  'plutoniumConvertCooldown',
  'plutoniumToGet',
  'bestPlutoniumToGet',
  'plutonium',
  'plutoniumUpgradesBought',
  'redSigils',
  'redSigilsToGet',
  'redSigilPower',
  'redSigilPowerPerSecond',
  'redSigilUpgrade1Cost',
  'redSigilUpgrade2Cost',
  'redSigilUpgrade3Cost',
  'redSigilUpgradesBought',
  'orangeSigils',
  'orangeSigilsToGet',
  'orangeSigilPower',
  'orangeSigilPowerPerSecond',
  'orangeSigilUpgrade1Cost',
  'orangeSigilUpgrade2Cost',
  'orangeSigilUpgrade3Cost',
  'orangeSigilUpgradesBought',
  'yellowSigils',
  'yellowSigilsToGet',
  'yellowSigilPower',
  'yellowSigilPowerPerSecond',
  'yellowSigilUpgrade1Cost',
  'yellowSigilUpgrade2Cost',
  'yellowSigilUpgrade3Cost',
  'yellowSigilUpgradesBought',
  'holyTetrahedrons',
  'holyTetrahedronsToGet',
  'holyTetrahedronUpgradesUnlocked',
  'holyTetrahedronUpgradesBought',
  'holyOctahedrons',
  'holyOctahedronsToGet',
  'holyOctahedronUpgradesUnlocked',
  'holyOctahedronUpgradesBought',
  'holyFire',
  'holyFirePerSecond',
  'holyFireUpgradeCosts',
  'holyFireUpgradesBought',
  'holyFireAutoMaxAll',
  'holyDodecahedrons',
  'holyDodecahedronsToGet',
  'holyDodecahedronUpgradesUnlocked',
  'holyDodecahedronUpgradesBought',
  'planets',
  'planetEffect',
  'planetCosts',
  'planetsFormed',
  'superclusters',
  'superclusterCost',
  'hypergodsDefeated',
  'cosmicPlague',
  'cosmicPlaguePerSecond',
  'spores',
  'sporeCost',
  'plagueUpgradeCosts',
  'plagueUpgradesBought',
  'plagueAutoMaxAll',
  'oganesson',
  'oganessonPerSecond',
  'oganessonUpgradesBought',
  'lightEssence',
  'lightEssencePerSecond',
  'lightEssenceUpgradeCosts',
  'lightEssenceUpgradesBought',
  'darkEssence',
  'darkEssencePerSecond',
  'darkEssenceUpgradeCosts',
  'darkEssenceUpgradesBought',
  'deathEssence',
  'deathEssencePerSecond',
  'deathEssenceUpgradeCosts',
  'deathEssenceUpgradesBought',
  'finalityEssence',
  'finalityEssencePerSecond',
  'finalityEssenceUpgradeCosts',
  'finalityEssenceUpgradesBought',
  'nuclearPasta',
  'nuclearPastaCost',
  'nuclearPastaState',
  'nuclearPastaStateInfo',
  'nuclearPastaCooldown',
  'nuclearPastaExtended',
  'nuclearPastaUpgradesBought',
  'finalityCubes',
  'finalityCubeCost',
  'finalityCubeEffect',
  'finalityBoosts',
  'finalityBoostCost',
  'finalityBoostBoosts',
  'finalityBoostBoostCost',
] as const

/** The pure state half of pristine reset(). Fresh allocations per call. */
export function createInitialState(now: () => number): GameState {
  return {
    unlockedAchievements: [0,0,0,0,0,0,0,0,0,0,0],
    unlocks: 0,
    lastMajorChangeVersion: 3,
    lastUpdate: now(),
    lastSave: 0,
    lastSigilReset: now(),
    timePlayed: 0,
    backgroundPatternOn: true,
    confirmations: [true, true, true],
    achievementFlashActive: false,
    currentTab: 1,
    dragonName: "Unnamed dragon",
    sigilResetterActive: false,
    sigilResetterType: 0,
    sigilResetterMode: 0,
    sigilResetterAmount: new Dec(1),
    sigilResetterGold: new Dec(1),
    sigilResetterTime: new Dec(1),
    sigilResetterCycle: false,
    sigilResetterCycleMode: 0,
    gold: new Dec(0),
    goldPerSecond: new Dec(0),
    miners: new Dec(0),
    minerCost: new Dec(20),
    fire: new Dec(0),
    firePerSecond: new Dec(1),
    fireGoldMultiplier: new Dec(1),
    fireAutoMaxAll: true,
    fireUpgrade1Bought: new Dec(0),
    fireUpgrade1Cost: new Dec(50),
    fireUpgrade2Bought: new Dec(0),
    fireUpgrade2Cost: new Dec(100),
    fireUpgrade3Bought: new Dec(0),
    fireUpgrade3Cost: new Dec(100),
    fireUpgrade4Bought: new Dec(0),
    fireUpgrade4Cost: new Dec(500),
    fireUpgrade5Bought: new Dec(0),
    fireUpgrade5Cost: new Dec(500),
    fireUpgrade6Bought: new Dec(0),
    fireUpgrade6Cost: new Dec(2e7),
    dragonStage: 1,
    platinumConvertCooldown: 0,
    platinumToGet: new Dec(0),
    bestPlatinumToGet: new Dec(0),
    platinum: new Dec(0),
    platinumUpgradesBought: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    magic: new Dec(0),
    magicToGet: new Dec(0),
    magicEffect: new Dec(1),
    goldPerClick: new Dec(1),
    minerAutoBuyMax: true,
    magicUpgradesBought: [],
    darkMagicUpgradesBought: [],
    voidMagicUpgradesBought: [],
    selectedChallenges: [false, false, false, false],
    challengesActive: false,
    noOfSelectedChallenges: 0,
    magicScoreToGet: new Dec(0),
    magicScore1: new Dec(0),
    magicScore2: new Dec(0),
    magicScore3: new Dec(0),
    magicScore4: new Dec(0),
    magifolds: new Dec(1),
    uraniumConvertCooldown: 0,
    uraniumToGet: new Dec(0),
    bestUraniumToGet: new Dec(0),
    uranium: new Dec(0),
    uraniumUpgradesBought: [0, 0, 0, 0, 0],
    dragonTimeSpent: new Dec(0),
    dragonTimeCooldown: 0,
    dragonFood: new Dec(0),
    dragonFeedCost: new Dec(100000000),
    dragonTimeEffect: new Dec(1),
    dragonPets: 0,
    cyanSigils: new Dec(0),
    cyanSigilsToGet: new Dec(0),
    cyanSigilPower: new Dec(0),
    cyanSigilPowerPerSecond: new Dec(0),
    cyanSigilUpgrade1Cost: new Dec(1),
    cyanSigilUpgrade2Cost: new Dec(20),
    cyanSigilUpgrade3Cost: new Dec(500),
    cyanSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    blueSigils: new Dec(0),
    blueSigilsToGet: new Dec(0),
    blueSigilPower: new Dec(0),
    blueSigilPowerPerSecond: new Dec(0),
    blueSigilUpgrade1Cost: new Dec(1),
    blueSigilUpgrade2Cost: new Dec(20),
    blueSigilUpgrade3Cost: new Dec(100),
    blueSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    indigoSigils: new Dec(0),
    indigoSigilsToGet: new Dec(0),
    indigoSigilPower: new Dec(0),
    indigoSigilPowerPerSecond: new Dec(0),
    indigoSigilUpgrade1Cost: new Dec(1),
    indigoSigilUpgrade2Cost: new Dec(20),
    indigoSigilUpgrade3Cost: new Dec(400),
    indigoSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    violetSigils: new Dec(0),
    violetSigilsToGet: new Dec(0),
    violetSigilPower: new Dec(0),
    violetSigilPowerPerSecond: new Dec(0),
    violetSigilUpgrade1Cost: new Dec(1),
    violetSigilUpgrade2Cost: new Dec(5),
    violetSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    pinkSigils: new Dec(0),
    pinkSigilsToGet: new Dec(0),
    pinkSigilPower: new Dec(0),
    pinkSigilPowerPerSecond: new Dec(0),
    pinkSigilUpgrade1Cost: new Dec(1),
    pinkSigilUpgrade3Cost: new Dec(150000),
    pinkSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    knowledge: new Dec(0),
    highestKnowledge: new Dec(0),
    knowledgeTradeLevel: new Dec(1),
    knowledgeTradeLevelCap: new Dec(3),
    knowledgeTrade1SigilTypes: [1, 2, 3],
    knowledgeTrade1Amounts: [new Dec(0), new Dec(0), new Dec(0)],
    knowledgeTrade1Multipliers: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    knowledgeTrade1Reward: new Dec(0),
    knowledgeTrade2SigilTypes: [1, 2, 3],
    knowledgeTrade2Amounts: [new Dec(0), new Dec(0), new Dec(0)],
    knowledgeTrade2Multipliers: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    knowledgeTrade2Reward: new Dec(0),
    knowledgeTrade3SigilTypes: [1, 2, 3],
    knowledgeTrade3Amounts: [new Dec(0), new Dec(0), new Dec(0)],
    knowledgeTrade3Multipliers: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    knowledgeTrade3Reward: new Dec(0),
    knowledgeUpgradesBought: [new Dec(0), new Dec(0), new Dec(0)],
    knowledgeUpgradeCosts: [new Dec(20), new Dec(50)],
    knowledgeAutoMaxAll: true,
    tomes: new Dec(0),
    totalTomes: new Dec(0),
    tomeCost: new Dec(100000),
    tomeUpgradesBought: [],
    blueFire: new Dec(0),
    blueFirePerSecond: new Dec(0),
    blueFireUpgradeCosts: [new Dec(500), new Dec(1000), new Dec(50000), new Dec(5e7), new Dec(1.5e8), new Dec(1e11)],
    blueFireUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    blueFireAutoMaxAll: true,
    blood: new Dec(0),
    bloodPerSecond: new Dec(0),
    currentHellLayer: 1,
    inHell: false,
    plutoniumConvertCooldown: 0,
    plutoniumToGet: new Dec(0),
    bestPlutoniumToGet: new Dec(0),
    plutonium: new Dec(0),
    plutoniumUpgradesBought: [0, 0, 0, 0, 0],
    redSigils: new Dec(0),
    redSigilsToGet: new Dec(0),
    redSigilPower: new Dec(0),
    redSigilPowerPerSecond: new Dec(0),
    redSigilUpgrade1Cost: new Dec(1),
    redSigilUpgrade2Cost: new Dec(1500),
    redSigilUpgrade3Cost: new Dec(50000),
    redSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    orangeSigils: new Dec(0),
    orangeSigilsToGet: new Dec(0),
    orangeSigilPower: new Dec(0),
    orangeSigilPowerPerSecond: new Dec(0),
    orangeSigilUpgrade1Cost: new Dec(1),
    orangeSigilUpgrade2Cost: new Dec(2500),
    orangeSigilUpgrade3Cost: new Dec(250000),
    orangeSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    yellowSigils: new Dec(0),
    yellowSigilsToGet: new Dec(0),
    yellowSigilPower: new Dec(0),
    yellowSigilPowerPerSecond: new Dec(0),
    yellowSigilUpgrade1Cost: new Dec(1),
    yellowSigilUpgrade2Cost: new Dec(4000),
    yellowSigilUpgrade3Cost: new Dec(2000000),
    yellowSigilUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    holyTetrahedrons: new Dec(0),
    holyTetrahedronsToGet: new Dec(0),
    holyTetrahedronUpgradesUnlocked: [true],
    holyTetrahedronUpgradesBought: [],
    holyOctahedrons: new Dec(0),
    holyOctahedronsToGet: new Dec(0),
    holyOctahedronUpgradesUnlocked: [true],
    holyOctahedronUpgradesBought: [],
    holyFire: new Dec(0),
    holyFirePerSecond: new Dec(0),
    holyFireUpgradeCosts: [new Dec(500), new Dec(1000), new Dec(10000), new Dec(50000), new Dec(1e7), new Dec(1)],
    holyFireUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    holyFireAutoMaxAll: true,
    holyDodecahedrons: new Dec(0),
    holyDodecahedronsToGet: new Dec(0),
    holyDodecahedronUpgradesUnlocked: [true],
    holyDodecahedronUpgradesBought: [],
    planets: new Dec(0),
    planetEffect: new Dec(1),
    planetCosts: [new Dec(1e30), new Dec(1e15), new Dec(1e5)],
    planetsFormed: [new Dec(0), new Dec(0), new Dec(0)],
    superclusters: new Dec(0),
    superclusterCost: new Dec(25),
    hypergodsDefeated: 0,
    cosmicPlague: new Dec(0),
    cosmicPlaguePerSecond: new Dec(0),
    spores: new Dec(0),
    sporeCost: new Dec("ee7500"),
    plagueUpgradeCosts: [new Dec(25), new Dec(100), new Dec(100000), new Dec(1e6), new Dec(1e13)],
    plagueUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    plagueAutoMaxAll: true,
    oganesson: new Dec(0),
    oganessonPerSecond: new Dec(0),
    oganessonUpgradesBought: [0, 0, 0, 0, 0, 0, 0],
    lightEssence: new Dec(0),
    lightEssencePerSecond: new Dec(0),
    lightEssenceUpgradeCosts: [new Dec(100), new Dec(600), new Dec(3000)],
    lightEssenceUpgradesBought: [new Dec(0), new Dec(0), new Dec(0)],
    darkEssence: new Dec(0),
    darkEssencePerSecond: new Dec(0),
    darkEssenceUpgradeCosts: [new Dec(100), new Dec(1000), new Dec(10000)],
    darkEssenceUpgradesBought: [new Dec(0), new Dec(0), new Dec(0)],
    deathEssence: new Dec(0),
    deathEssencePerSecond: new Dec(0),
    deathEssenceUpgradeCosts: [new Dec(1000), new Dec(10000), new Dec(200000), new Dec(1e7), new Dec(1e40)],
    deathEssenceUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    finalityEssence: new Dec(0),
    finalityEssencePerSecond: new Dec(0),
    finalityEssenceUpgradeCosts: [new Dec(1000), new Dec(4000), new Dec(1e15), new Dec(1e20)],
    finalityEssenceUpgradesBought: [new Dec(0), new Dec(0), new Dec(0), new Dec(0)],
    nuclearPasta: new Dec(0),
    nuclearPastaCost: new Dec("ee3.5e6"),
    nuclearPastaState: 1,
    nuclearPastaStateInfo: true,
    nuclearPastaCooldown: 30,
    nuclearPastaExtended: false,
    nuclearPastaUpgradesBought: [false, false, false, false],
    finalityCubes: new Dec(0),
    finalityCubeCost: new Dec("ee7.5e9"),
    finalityCubeEffect: new Dec(1),
    finalityBoosts: new Dec(0),
    finalityBoostCost: new Dec("ee2.5e10"),
    finalityBoostBoosts: new Dec(0),
    finalityBoostBoostCost: new Dec("ee1.5e11"),
  }
}
